import Button from "./Button";

export function CancelButton({ onClick }) {
  return (
    <Button
      type="destructive"
      label="Cancel"
      size="small"
      disabled={false}
      loading={false}
      stretch={false}
      center={true}
      onClick={onClick}
    />
  );
}
